import React, { useEffect } from "react";
import Helmet from "react-helmet";
import Footer from "./footer";
import Header from "./header";
import { useSelector, useDispatch } from "react-redux";
import { getById } from "../state/action";
import { useParams } from "react-router-dom";
import {Link} from "react-router-dom"
function GemDetail() {
    const gem = useSelector((state) => state.gemstone.gemStone);
  let params = useParams();
  let gemId = params.id;

  console.log(gem);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getById(gemId));
  });
  return (
    <div>
      <Header />
      {gem.map((i) => {
        return (
          <section
            className="page-title centred"
            style={{
              backgroundImage: "url(" + i.image + ")",
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              width: "100vw",
              height: "50vh",
            }}
          >
            <div className="auto-container">
              <div className="content-box">
                <div className="title">
                  <h1>{i.name}</h1>
                </div>
                <ul className="bread-crumb clearfix">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        );
      })}

      <section className="sidebar-page-container">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 content-side">
              <div className="blog-details-content">
                <div className="news-block-one">
                  {gem.map((i) => {
                    return (
                      <div className="inner-box">
                        <div className="lower-content">
                          <h2>{i.name}</h2>
                          <div className="text">
                            <p>{i.description}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div className="inner">
                    <br></br>
                    <h2>Type</h2>
                    <br></br>
                  </div>
                  {gem[0]?.type.map((i) => {
                    return (
                      <div className="two-column">
                        <div className="row align-items-center clearfix">
                          <div className="col-lg-12 col-md-6 col-sm-12 image-column"></div>
                          <div className="col-lg-12 col-md-6 col-sm-12 text-column">
                            <p>
                              <span
                                style={{
                                  "font-weight": "bold",
                                  "font-size": "20px",
                                  font_color: "black",
                                }}
                              >
                                {i.name}
                              </span>{" "}
                              <br></br>
                              {i.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div>
                  
                </div>
                <div className="inner">
                    <br></br>
                    <h2>Quality</h2>
                    <br></br>
                  </div>
                {gem[0]?.quality.map((i) => {
                    return (
                      <div className="two-column">
                        <div className="row align-items-center clearfix">
                          <div className="col-lg-12 col-md-6 col-sm-12 image-column"></div>
                          <div className="col-lg-12 col-md-6 col-sm-12 text-column">
                            <p>
                              <span
                                style={{
                                  "font-weight": "bold",
                                  "font-size": "20px",
                                  font_color: "black",
                                }}
                              >
                                {i.name}
                              </span>{" "}
                              <br></br>
                              {i.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <Helmet>
        <script src="assets/js/jquery.js"></script>
        <script src="assets/js/popper.min.js"></script>
        <script src="assets/js/bootstrap.min.js"></script>
        <script src="assets/js/owl.js"></script>
        <script src="assets/js/wow.js"></script>
        <script src="assets/js/validation.js"></script>
        <script src="assets/js/jquery.fancybox.js"></script>
        <script src="assets/js/appear.js"></script>
        <script src="assets/js/scrollbar.js"></script>
        <script src="assets/js/isotope.js"></script>

        <script src="assets/js/script.js"></script>
      </Helmet>
    </div>
  );
}
export default GemDetail;
